import React, { useState, useEffect } from 'react';
import parse from 'html-react-parser';
import { useNavigate } from 'react-router-dom';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import DatePicker from 'react-datepicker';
import "../../../node_modules/react-datepicker/dist/react-datepicker.css";

import Loginheader from '../Loginheader';
import Menu from '../Menu';

import * as Common from '../Common';




function Downloads() {
    const navigate = useNavigate();
    const sid = sessionStorage.getItem('sessionId');
    const [onceRun, setOnceRun] = useState(false);

    useEffect(() => {
        if (onceRun) {
            return;
        } else {
            Common.callApi(Common.apiRight, [sid, 'all', 'DOWNLOADS'], function (result) {
                let resp = JSON.parse(result);
                if (resp.query === "1") {

                } else {
                    navigate('/'); // no query right
                }
            });
            setOnceRun(true);
        }
    }, [onceRun, sid, navigate]);

    function btnA2FormV1() {
        window.open("a2v1/A/0", "_blank");
    }
    function btnA2FormV1Avanse() {
        window.open("a2v1/A/13", "_blank");
    }

    function btnAndroidApp() {
        window.open("opendownload/zeneremit.zip", "_blank");
    }

    // function btnZeneremitReport() {
    //     window.open("/report", "_blank");
    // }

    return (
        <>
            <Loginheader></Loginheader>
            <Menu></Menu>
            <Container fluid >
                <Row>
                    <Col>
                        <h1>Downloads</h1>
                    </Col>
                </Row>
                <Row>
                    <Col>&nbsp;</Col>
                </Row>
                <Row>
                    <Col>
                        <ul>
                            <li className='cursorPointer' onClick={(e) => btnA2FormV1()} >A2 Form</li>
                            <li className='cursorPointer' onClick={(e) => btnA2FormV1Avanse()}>A2 Form (Avanse)</li>
                            <li className='cursorPointer' onClick={(e) => btnAndroidApp()}>Android App</li>
                        </ul>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        &nbsp;
                    </Col>
                </Row>
            </Container>
        </>
    );
}
export default Downloads;